import React from "react";
import { Box, Heading, Text, Button, VStack } from "@chakra-ui/react";
import { useHistory } from "react-router-dom";

const NotFound = () => {
  const history = useHistory();

  const handleGoHome = () => {
    history.push("/");
  };

  return (
    <Box textAlign='center' py={10} px={6}>
      <Heading
        display='inline-block'
        as='h1'
        size='4xl'
        bgGradient='linear(to-r, teal.400, teal.600)'
        bgClip='text'
      >
        404
      </Heading>
      <Text fontSize='24px' mt={3} mb={2}>
        Oops! Page not found.
      </Text>
      <Text color='gray.500' mb={6}>
        The page you’re looking for does not seem to exist.
      </Text>

      <VStack spacing={4}>
        <Button colorScheme='teal' size='lg' onClick={handleGoHome}>
          Go Home
        </Button>
      </VStack>
    </Box>
  );
};

export default NotFound;
